import React from 'react';
import { createInertiaApp } from '@inertiajs/react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { MuiThemeProvider } from './providers/ThemeProvider';
import { register } from './serviceWorkerRegistration';
import MainLayout from './components/layouts/MainLayout';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './bootstrap';

const appName = import.meta.env.VITE_APP_NAME || 'WannaCollab';

createInertiaApp({
  title: (title) => `${title ? `${title} - ` : ''} ${appName}`,
  resolve: (name) => {
    const pages = import.meta.glob('./pages/**/*.jsx', { eager: true });
    let page = pages[`./pages/${name}.jsx`];
    page.default.layout = page.default.layout || (page => <MainLayout>{page}</MainLayout>);
    return page;
  },
  setup({ el, App, props }) {
    createRoot(el).render(<MuiThemeProvider>
      <App {...props} />
    </MuiThemeProvider>);
    
    // hydrateRoot(el, <MuiThemeProvider>
    //   <App {...props} />
    // </MuiThemeProvider>);
    register();
  },
});